import { postAppGraphql } from "./appGraphqlService";

export type DistrictOption = {
  id: string;
  name: string;
  district_id: string;
  state_id: string;
  source: string;
};

const DISTRICTS_FILTER_QUERY = `
  query DistrictsFilter($excludeDeleted: Boolean, $assessmentMode: [String!]) {
    districtList(sort: name, orderBy: Asc, excludeDeleted: $excludeDeleted, assessmentMode: $assessmentMode) {
      nodes {
        id
        name
        district_id
        state_id
        source
      }
    }
  }
`;

type DistrictsFilterResponse = {
  districtList?: {
    nodes?: DistrictOption[];
  };
};

export async function fetchDistricts(
  token: string,
): Promise<DistrictOption[]> {
  const payload = await postAppGraphql<DistrictsFilterResponse>({
    token,
    operationName: "DistrictsFilter",
    query: DISTRICTS_FILTER_QUERY,
    variables: {
      excludeDeleted: true,
      assessmentMode: ["activities", "benchmarks"],
    },
  });

  return payload.data?.districtList?.nodes ?? [];
}
